import { render, staticRenderFns } from "./GlobalOverview.vue?vue&type=template&id=4fbb5658&scoped=true"
import script from "./GlobalOverview.vue?vue&type=script&lang=js"
export * from "./GlobalOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbb5658",
  null
  
)

export default component.exports